<div *ngIf="content.showOverlayMessage" class="form-alert" id="formAlertId">
  <idp-form-alert
    [message]="content.overlayMessage"
    [showCloseButton]="true"
    (closePopup)="closePopup()"
  ></idp-form-alert>
</div>

<idp-login-header
  [ngClass]="{
    'login-header-margin':
      content.formAttributes?.errorAlertBanner &&
      content.formAttributes?.submitAttempt
  }"
  [loginHeaderContent]="content.pageContent?.pageHeader"
></idp-login-header>
<section
  *ngIf="
    content.formAttributes?.submitAttempt &&
    content.formAttributes?.errorAlertBanner
  "
>
  <idp-alert-warning
    *ngIf="content.formAttributes.errorCount"
    (firstInvalidFieldFocusEvent)="onFocusFirstInvalidField()"
    [cntError]="content.formAttributes.errorCount"
    [errorMessage]="content.pageContent.messages.alertWarning"
  ></idp-alert-warning>
</section>

<form class="set-password" [formGroup]="formGroup" (ngSubmit)="submit()">
  <div class="set-password__content">
    <div class="set-password__content__new-password">
      <idp-input
        [labelTxt]="content.pageContent?.newPasswordLabel"
        [trimInput]="true"
        [type]="content.pageContent?.showPassword ? 'text' : 'password'"
        (keyup)="updatePasswordHintStatus($event)"
        (value)="updatePasswordHintStatus($event)"
        (focusOut)="onFocussedOut('newPassword')"
        [id]="'newPassword'"
        formControlName="newPassword"
      ></idp-input>
      <button
        type="button"
        class="set-password__content__new-password__eye-icon"
        [ngClass]="{ 'show-eye-icon': content.pageContent?.showPassword }"
        (click)="onEyeIconClick()"
      ></button>
      <div
        *ngIf="showErrorMessageNewPassword"
        class="set-password__content--error-message"
      >
        <span
          class="errorMessageText"
          [innerHTML]="content.pageContent.messages?.newPasswordErrorMessage"
        ></span>
      </div>
    </div>
    <div class="set-password__content__confirm-password">
      <idp-input
        [labelTxt]="content.pageContent?.confirmPasswordLabel"
        [trimInput]="true"
        [type]="content.pageContent?.showPassword ? 'text' : 'password'"
        (focusOut)="onFocussedOut('confirmPassword')"
        [id]="'confirmPassword'"
        formControlName="confirmPassword"
        (keyup)="updatePasswordHintStatus($event)"
        (value)="updatePasswordHintStatus($event)"
      ></idp-input>
      <span
        *ngIf="showErrorMessagePasswordMismatch || showOnPasswordsMatch"
        class="set-password__content__confirm-password--match"
        [ngClass]="{ mismatch: showOnPasswordsMatch }"
      ></span>
      <div
        *ngIf="showErrorMessageConfirmPassword"
        class="set-password__content--error-message"
      >
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.messages?.confirmPasswordErrorMessage
          "
        ></span>
      </div>
    </div>
  </div>
  <div class="set-password__password-requirements">
    <div class="must-contain">
      <h2 class="must-contain__heading">
        {{ content.pageContent?.mustContainLabel }}
      </h2>
      <ul class="must-contain__list">
        <li
          class="must-contain__list__items"
          [ngClass]="{
            'must-contain__list__items--success':
              'success' ===
              content.pageContent.messages?.mustContainValidationList[i],
            'must-contain__list__items--error':
              'error' ===
              content.pageContent.messages?.mustContainValidationList[i]
          }"
          *ngFor="
            let item of content.pageContent?.mustContainList;
            let i = index
          "
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="cannot-contain">
      <h2 class="cannot-contain__heading">
        {{ content.pageContent?.canNotContainLabel }}
      </h2>
      <ul class="cannot-contain__list">
        <li
          class="cannot-contain__list__items"
          [ngClass]="{
            'cannot-contain__list__items--success':
              'success' ===
              content.pageContent.messages.cannotContainValidationList[i],
            'cannot-contain__list__items--error':
              'error' ===
              content.pageContent.messages.cannotContainValidationList[i]
          }"
          *ngFor="
            let item of content.pageContent?.cannotContainList;
            let i = index
          "
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
  <div class="set-password__submit-btn">
    <idp-button
      [label]="content.pageContent?.nextDisplayView?.button_modal"
      [size]="'full-width'"
      [elementType]="'submit'"
      [disabled]="
        content.formAttributes?.disableActionButton || !!formGroup.invalid
      "
    ></idp-button>
  </div>
</form>
